import RestBase from '@/services/base/RestBase'
import { ApiEnum } from '@/constants/ApiEnum'

export default class MunicipioService  extends RestBase {
    constructor() {
        super(ApiEnum.BACKEND, '/citsbe/recarga', 2);
    }
    
    async getListaMunicipio() {
        return this.get(`/municipio/findAll`);
    } 
}